<template>
  <div class="dialog-warp">
    <el-form ref="info" :model="info" label-width="140px" :rules="rules" size="small">
      <div style="position: relative">
        <el-row class="dialog-form">
          <el-col :span="20" :offset="1">
            <el-form-item label="车牌号：" prop="vaVehicleNumber">
              <v-card-number v-model.trim="info.vaVehicleNumber" @getCarNumber="getCarNumber" 
              :provinceFather="info.province"
              :letterFather="info.letter"
              :licensePlateNumberFather="info.licensePlateNumber"
              v-if="!vaId || info.vaVehicleNumber"></v-card-number>
            </el-form-item>
            <el-form-item label="车主姓名：" prop="vaVehicleUserId">
              <el-select v-model.trim="info.vaVehicleUserId" placeholder="请选择车主姓名" filterable>
                <el-option v-for="(item,index) in carOwnerList" :key="item.userId" :label="item.userName"
                           :value="item.userId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="租赁有效期：" prop="vaVehicleEndTime">
              <el-date-picker
                v-model="info.vaVehicleEndTime"
                value-format="yyyy-MM-dd hh:mm:ss"
                type="datetime"
                placeholder="请选择租赁有效期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="可用停车场：" prop="vaCarParkList">
              <el-select v-model.trim="info.vaCarParkList" placeholder="请选择可用停车场" @change="changeCarParkGroup" filterable multiple collapse-tags>
                <el-option v-for="(item,index) in carParkGroupList" :key="item.carParkId" :label="item.parkingName"
                           :value="item.carParkId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="text-center" style="margin-top: 20px;">
      <el-button type="success" size="mini" @click.stop="submits">保存</el-button>
    </div>
  </div>
</template>

<script>
  import * as getData from "../service/getData";
  import * as global from '../config/mUtils'

  export default {
    data() {
      const checkCarNumber = (rule, value, callback) => {
        let info = this.info;
        let reg = /(^[A-Z0-9]{5}$)|(^[A-Z0-9]{6}$)|(^[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]$)/;
        // let reg = /(^[A-Z0-9]{5}$)|(^[A-Z0-9]{6}$)/;
        if (!info.province) {
          callback("请选择省字母！");
          return;
        }
        if (!info.letter) {
          callback("请选择英文字母！");
          return;
        }
        if (!info.licensePlateNumber) {
          callback("请输入5/6位车牌号！");
          return;
        }
        if (!reg.test(info.licensePlateNumber)) {
          callback("5/6位车牌号格式为5/6位的大写字母 + 数字组合！");
          return;
        }
        let carNumber = `${info.province ? info.province : ""}${info.letter ? info.letter : ""}${info.licensePlateNumber ? info.licensePlateNumber : ""}`;
        if (!global.cardNumRule.test(carNumber)) {
          callback("该车牌号不规范！");
          return;
        }
        callback();
      };
      return {
        info: {
          province: '',
          letter: '',
          licensePlateNumber: '',
          vaVehicleUserId: '',
          vaVehicleNumber: '',
          vaVehicleEndTime: '',
          vaCarParkIds: '',
          vaCarParkList: [],
        },
        rules: {
          vaVehicleNumber: [
            { required: true, validator: checkCarNumber, trigger: ["blur", "change"] }
          ],
          vaVehicleUserId: [
            { required: true, message: "请选择车主姓名", trigger: ["blur", "change"] }
          ],
          vaVehicleEndTime: [
            { required: true, message: "请选择租赁有效期", trigger: ["blur", "change"] }
          ],
          vaCarParkList: [
            { required: true, message: "请选择可用停车场", trigger: ["blur", "change"] }
          ]
        },
        submitLoading: false,
        billSelectList: [],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now();
          },
          shortcuts: [{
            text: '半年后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 180);
              picker.$emit('pick', date);
            }
          }, {
            text: '一年后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit('pick', date);
            }
          }, {
            text: '二年后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365*2);
              picker.$emit('pick', date);
            }
          }, {
            text: '三年后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365*3);
              picker.$emit('pick', date);
            }
          }]
        },
        dateSection:[],
        carParkGroupList: [],
        carOwnerList: [],
      };
    },
    created() {
    },
    mounted() {
      this.getAllCarParkGroupList();//获取车场列表
      this.getAllCarOwnerList();//车主列表
      this.init();
    },
    props: ["vaId"],
    computed: {},
    methods: {
      getAllCarOwnerList(){
        getData.getAllCarOwnerList().then(res =>{
          if(res.data.code == 1){
            this.carOwnerList = res.data.data||[];
          }
        })
      },
      changeCarParkGroup(val){
        if(val){
          let carParkNameList = [];
          this.carParkGroupList.forEach(item =>{
            val.forEach(ele =>{
              if(ele === item.carParkId){
                carParkNameList.push(item.parkingName);
              }
            })
          })
          this.info.vaCarParkName = carParkNameList.join(',');
        }
      },
      getAllCarParkGroupList(){
        getData.getAllCarParkGroupList().then(res =>{
          if(res.data.code == 1){
            this.carParkGroupList = res.data.data||[];
          }
        })
      },
      getCarNumber(province, letter, licensePlateNumber) {
        let info = this.info;
        info.province = province;
        info.letter = letter;
        info.licensePlateNumber = licensePlateNumber;
        info.vaVehicleNumber = province+letter+licensePlateNumber
      },
      init() {
        if (this.vaId) {
          getData.getVehicleDetail({vaId:this.vaId}).then(res => {
            if (res.data.code != 1) {
              this.$message.error(res.data.message);
              return;
            }
            let data = res.data.data.vehicleApproveForm;
            let vehicle = res.data.data.carNumber;
            let vaCarParkIds = data.vaCarParkIds.split(',').map(item => {
                return Number(item)
            })
            this.info = {
              vaId: data.vaId,
              province: vehicle[0],
              letter: vehicle[1],
              licensePlateNumber: vehicle[2],
              vaVehicleUserId: data.vaVehicleUserId,
              vaVehicleNumber: data.vaVehicleNumber,
              vaVehicleEndTime: data.vaVehicleEndTime,
              vaCarParkIds: data.vaCarParkIds,
              vaCarParkList: vaCarParkIds,
              vaCarParkName: data.vaCarParkName,
            }
          });
        }
      },
      lookBigImg(imgUrl) {
        if (imgUrl) {
          this.imgUrl = imgUrl + "?x-oss-process=image/resize,w_500/auto-orient,1";
          this.lookBigImgDialog = true;
        } else {
          this.$message.warning("抱歉，该图片无法查看！");
        }
      },
      submits(type) {
        this.$refs["info"].validate((valid) => {
          if (valid) {
            this.info.vaCarParkIds = this.info.vaCarParkList.join(',');
            let info = JSON.parse(JSON.stringify(this.info));
            this.submitLoading = true;
            if (this.vaId) {
              this.edit();
            } else {
              this.add();
            }
          } else {
          }
        });
      },
      add() {
        getData.addVehicleApprove(this.info).then(res => {
          this.submitLoading = false;
          if (res.data.code === 1) {
            this.$message({
              type: "success",
              message: "新增成功!"
            });
            this.close(2);
          } else {
            this.$message({
              type: "info",
              message: res.data.message
            });
          }
        }).catch(err => {
          console.log(err);
          this.submitLoading = false;
        });
      },
      edit() {
        getData.editVehicleApprove(this.info).then(res => {
          this.submitLoading = false;
          if (res.data.code === 1) {
            this.$message({
              type: "success",
              message: "编辑成功!"
            });
            this.close(2);
          } else {
            this.$message({
              type: "info",
              message: res.data.message
            });
          }
        }).catch(err => {
          console.log(err);
          this.submitLoading = false;
        });
      },
      onFileChange(obj, row, index) {
        let arr = [];
        if (obj.file) {
          arr.push(obj.file);
        }
        row.monitorBlackListPic = arr;
      },
      close(type) {
        if (type === 1) {
          this.$emit("search");
        } else if (type === 2) {
          this.$emit("init");
        }
        this.$emit("closeDialog");
      },
    },
    components: {},
    watch: {}
  };
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';

  .g-padding20 {
    padding: 20px 20px 10px 20px;
  }

  .g-info-cont {
    .p1 {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      margin-bottom: 10px;
    }
  }

  .g-imgboxs {
    width: 112px;
    height: 112px;
    margin-right: 30px;
  }

  .g-threebtns {
    border-top: 1px solid #cccccc;
    margin-top: 10px;

    .el-button {
      flex: 1;
      border-right: 1px solid #cccccc;

      &:last-child {
        border-right: 0 none;
      }
    }
  }

  .p-state {
    position: absolute;
    right: 0;
    top: 20px;
    width: 122px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    color: #ffffff;
    font-size: 16px;
    border-radius: 34px 0 0 34px;
  }

  .p-green {
    background-color: #009966;
  }

  .p-red {
    background-color: rgba(255, 0, 0, 1);
  }

  .g-zhuyi {
    i {
      margin-right: 10px;
      color: #cccccc;
    }

    p {
      font-size: 12px;
      color: #cccccc;
      line-height: 1.5;
    }

  }

  .el-icon-error {
    position: absolute;
    right: -6px;
    top: -6px;
    color: #ff4d51;
    cursor: pointer;
    font-size: 16px;
    z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/components/parking-rental-application.vue